import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../lastProjects/LastProjects.css";
import axios from "axios";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";

const STATUS_OPTIONS = [
  "pending",
  "confirmed",
  "shipped",
  "delivered",
  "cancelled",
];

function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

function formatPayment(order) {
  const method = order?.payment?.method || "—";
  const status = order?.payment?.status || "—";
  return `${method} / ${status}`;
}

function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("");

  const token =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    const fetchOrders = async () => {
      try {
        setLoading(true);
        const params = {};
        if (statusFilter) params.status = statusFilter;
        const response = await axios.get("/orders", {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setOrders(response?.data?.orders || []);
      } catch (error) {
        toast.error("Failed to load orders.");
        setOrders([]);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [token, statusFilter]);

  const updateStatus = async (orderId, status) => {
    try {
      await axios.put(
        `/orders/${orderId}/status`,
        { status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setOrders((previous) =>
        previous.map((order) =>
          order._id === orderId ? { ...order, status } : order
        )
      );

      toast.success("Order status updated.");
    } catch (error) {
      toast.error("Failed to update order status.");
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <BeatLoader />
      </div>
    );
  }

  return (
    <main className="lastProjects dashboard-orders">
      <div className="container">
        <div className="title dashboard-orders-header">
          <h1>Orders</h1>
        </div>
        <div className="dashboard-orders-toolbar">
          <label htmlFor="orders-status-filter" className="orders-filter-label">
            Filter by status
          </label>
          <select
            id="orders-status-filter"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="dashboard-orders-filter-select"
          >
            <option value="">All</option>
            {STATUS_OPTIONS.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
            <option value="awaiting_payment">awaiting payment</option>
          </select>
        </div>
        <div className="table-container dashboard-orders-table-wrap">
          <div className="table dashboard-orders-table">
            <div className="head">
              <div className="col">
                <div>ID</div>
                <div>Customer</div>
                <div>Phone</div>
                <div>Total</div>
                <div>Payment</div>
                <div>Status</div>
                <div>Created At</div>
                <div>Actions</div>
              </div>
            </div>
            <div className="body">
              {orders.length === 0 ? (
                <div className="dashboard-orders-empty">
                  <p>No orders found.</p>
                </div>
              ) : (
              orders.map((order, index) => (
                <div className="col dashboard-orders-row" key={order._id}>
                  <div className="dashboard-orders-id">#{String(order?._id || index + 1).slice(-8).toUpperCase()}</div>
                  <div>{order?.customer?.fullName}</div>
                  <div>{order?.customer?.phone}</div>
                  <div>{Number(order?.totals?.total || 0).toFixed(2)} SAR</div>
                  <div>
                    {formatPayment(order)}
                  </div>
                  <div>
                    <select
                      value={
                        order?.status && STATUS_OPTIONS.includes(order.status)
                          ? order.status
                          : "pending"
                      }
                      onChange={(event) =>
                        updateStatus(order._id, event.target.value)
                      }
                      className="orders-status-select"
                      title="Update status"
                    >
                      {STATUS_OPTIONS.map((status) => (
                        <option key={status} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    {formatDate(order.createdAt)}
                  </div>
                  <div>
                    <Link
                      to={`/dashboard/orders/${order._id}`}
                      className="dashboard-orders-view-btn"
                    >
                      View details
                    </Link>
                  </div>
                </div>
              ))
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Orders;
